import ThemeProvider from 'lib/next-themes/provider';
import useTheme from 'lib/next-themes/use-theme';

export { ThemeProvider, useTheme };
